import { Box, BoxProps, Modal, ModalProps } from '@mui/material'
import React from 'react'

const CustomModal = ({
  children,
  boxProps,
  ...modalProps
}: ModalProps & {
  boxProps?: BoxProps
}) => {
  const { sx: boxSx, ...restBoxProps } = boxProps ?? {}

  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          outline: 'none',
          bgcolor: 'background.paper',
          color: (theme) => theme.palette.text.primary,
          ...boxSx
        }}
        {...restBoxProps}
      >
        {children}
      </Box>
    </Modal>
  )
}

export default CustomModal
